import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { acceptCookiePolicy } from '../../actions/user'
import { withTranslation } from '../../translations'

export const CookiePolicy = (props) => (
  <div
    className="card card-default mx-4 mt-4"
    style={{
      border: 'none',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.18)',
      background: '#eee',
      zIndex: 100,
    }}
  >
    <div className="card-body">
      <div className="mb-3">
        {props.t('cookie.notice')}&nbsp;
        <a
          href="https://www.fit3d.com/privacy/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {props.t('cookie.privacyPolicy')}
        </a>
        .
      </div>
      <div className="d-flex">
        <button
          className="btn btn-primary ml-auto"
          onClick={props.handleCookiePolicy}
        >
          {props.t('cookie.accept')}
        </button>
      </div>
    </div>
  </div>
)

CookiePolicy.propTypes = {
  handleCookiePolicy: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => ({
  handleCookiePolicy: () => {
    dispatch({ type: 'HIDE_COOKIE_NOTICE' })
    dispatch(acceptCookiePolicy())
  },
})

export default withTranslation(connect(null, mapDispatchToProps)(CookiePolicy))
